/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShippingData } from './ShippingData';
import {
    ShippingDataFromJSON,
    ShippingDataFromJSONTyped,
    ShippingDataToJSON,
    ShippingDataToJSONTyped,
} from './ShippingData';

/**
 * 
 * @export
 * @interface DailyShippingData
 */
export interface DailyShippingData {
    /**
     * 
     * @type {Array<ShippingData>}
     * @memberof DailyShippingData
     */
    shippings?: Array<ShippingData>;
}

/**
 * Check if a given object implements the DailyShippingData interface.
 */
export function instanceOfDailyShippingData(value: object): value is DailyShippingData {
    return true;
}

export function DailyShippingDataFromJSON(json: any): DailyShippingData {
    return DailyShippingDataFromJSONTyped(json, false);
}

export function DailyShippingDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): DailyShippingData {
    if (json == null) {
        return json;
    }
    return {
        
        'shippings': json['shippings'] == null ? undefined : ((json['shippings'] as Array<any>).map(ShippingDataFromJSON)),
    };
}

export function DailyShippingDataToJSON(json: any): DailyShippingData {
    return DailyShippingDataToJSONTyped(json, false);
}

export function DailyShippingDataToJSONTyped(value?: DailyShippingData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shippings': value['shippings'] == null ? undefined : ((value['shippings'] as Array<any>).map(ShippingDataToJSON)),
    };
}

